/* import __COLOCATED_TEMPLATE__ from './dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    item: any;
  };
  Blocks: {
    default: [];
  };
}

const DropDownItem = templateOnlyComponent<Signature>();
export default DropDownItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Common::DropDownItem': typeof DropDownItem;
    'common/dropdown-item': typeof DropDownItem;
  }
}
